"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeSamlRequest = void 0;
const uuid_1 = require("uuid");
const pako = __importStar(require("pako"));
const isNode_1 = require("./helpers/isNode");
function generateRandomXmlId() {
    return 'a' + (0, uuid_1.v4)();
}
function encodeSamlRequest({ xmlId = generateRandomXmlId(), consumerServiceUrl, audienceUri }) {
    const rawSamlRequest = `<samlp:AuthnRequest xmlns="urn:oasis:names:tc:SAML:2.0:metadata" xmlns:samlp="urn:oasis:names:tc:SAML:2.0:protocol" ID="${xmlId}" Version="2.0" IssueInstant="2020-12-07T15:12:01.804Z" IsPassive="false" AssertionConsumerServiceURL="${consumerServiceUrl}"><Issuer xmlns="urn:oasis:names:tc:SAML:2.0:assertion">${audienceUri}</Issuer></samlp:AuthnRequest>`;
    const deflated = pako.deflateRaw(rawSamlRequest);
    const b64encoded = (0, isNode_1.isNode)() ? Buffer.from(deflated).toString('base64') : require('buffer').Buffer.from(deflated).toString('base64');
    const encodedSAML = encodeURIComponent(b64encoded);
    return encodedSAML;
}
exports.encodeSamlRequest = encodeSamlRequest;
